module.exports = __webpack_public_path__ + "img/createAd.81eb9e43.svg";